import React from "react";

type Props = {
  size?: number;
};

export const BackCaretIcon = React.memo(({ size = 22 }: Props) => {
  return (
    <svg width={size} height={size} fill="none" viewBox="0 0 20 20">
      <path
        d="M.879 10.02L10.07.829l2.038 2.038-7.155 7.155 7.155 7.155-2.038 2.037-9.19-9.193z"
        fill="#323232"
      />
    </svg>
  );
});
